module.exports = __webpack_public_path__ + "img/overview.4dd7fdea.jpeg";